/**
 * Initializes flip card functionality.
 */
function initFlipCard() {
  document.querySelectorAll(".flip-toggle").forEach((flipToggle) => {
    setCardHeight();
    flipToggle.addEventListener("click", flip);
  });
}

/**
 * Handles the flip action for a flip card.
 *
 * @param {Event} event - The click event that triggered the flip action.
 */
function flip(event) {
  let card = event.currentTarget.closest(".flip-card");
  if (card) {
    card.classList.toggle("flipped");
  }
}

/**
 * Sets the height of the card item based on the height of the front and back faces.
 */
function setCardHeight() {
  document.querySelectorAll(".flip-toggle").forEach((flipToggle) => {
    const cardItem = flipToggle.closest(".card-item");

    const cardFaceFront = cardItem.querySelector(".card-face-front");
    const cardFaceBack = cardItem.querySelector(".card-face-back");

    if (cardFaceFront && cardFaceBack) {
      // Check if front or back face is taller and set the card item height accordingly.
      cardItem.style.height =
        Math.max(cardFaceFront.offsetHeight, cardFaceBack.offsetHeight) + "px";
    }
  });
}

// Run when document is ready.
document.addEventListener("DOMContentLoaded", initFlipCard);

// Run on window resize.
window.addEventListener("resize", setCardHeight);

// Run on screen orientation change.
screen.orientation.addEventListener("change", setCardHeight);
